import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { preloadScanbotEngine } from "./scanbotEnginePreload";

const isVConsoleEnabledByEnv =
  process.env.REACT_APP_ENABLE_VCONSOLE === "1" ||
  String(process.env.REACT_APP_ENABLE_VCONSOLE).toLowerCase() === "true";
 
if (isVConsoleEnabledByEnv) {
  const vConsoleModule = require("vconsole");
  const VConsole = vConsoleModule.default || vConsoleModule;
  new VConsole();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Warm the self-hosted Scanbot scanning engine in the background so document
// scanning does not race the ~16MB engine download inside the scan timer. This
// does not start the Scanbot trial clock (it only fetches static files).
preloadScanbotEngine();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
